import { render, staticRenderFns } from "./CheckBoxComponent.vue?vue&type=template&id=29f20b20"
import script from "./CheckBoxComponent.vue?vue&type=script&lang=js"
export * from "./CheckBoxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports